import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) {}

  getFiles(path: string = 'public/files'){
    return this.http.get(environment.apiUrl + 'admin/files', {params: { path }});
  }

  createFolder(data: any){
    return this.http.post(environment.apiUrl + 'admin/create/folder', data);
  }

  deleteItem(payload: any){
    return this.http.post(environment.apiUrl + 'admin/delete/folderOrFile', payload);
  }

  uploadFile(file: File, folder: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    return this.http.post<{ url: string }>(environment.apiUrl + 'admin/upload', formData, {
      reportProgress: true,
      observe: 'events'
    });
  }


}
